import { z } from "zod";
import { TEAM_SIDES } from "../types/rugby-score.js";
import { NETBALL_SCORE_EVENT_TYPES } from "../utils/netball-scoring.js";

export const recordNetballScoreEventSchema = z.object({
  team_side: z.enum(TEAM_SIDES),
  event_type: z.enum(NETBALL_SCORE_EVENT_TYPES).exclude(["correction"]),
  quarter: z.number().int().min(1).max(4),
  minute: z.number().int().min(0).max(120).optional().nullable(),
  player_id: z.string().min(1).optional().nullable(),
  note: z.string().max(500).optional().nullable(),
});

export const netballCorrectionSchema = z.object({
  team_side: z.enum(TEAM_SIDES),
  quarter: z.number().int().min(1).max(4),
  points: z.number().int(), // signed
  note: z.string().min(1).max(500),
  minute: z.number().int().min(0).max(120).optional().nullable(),
});

export type RecordNetballScoreEventInput = z.infer<typeof recordNetballScoreEventSchema>;
export type NetballCorrectionInput = z.infer<typeof netballCorrectionSchema>;
